// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1YyZ_","resendInfoText":"OnGoingPaymentBox_resendInfoText__wWyfl"};